const AHorseWithNoName = [
	'On the first part of the journey,',
	'I was looking at all the life.',
	'There were plants and birds, and rocks and things,',
	'There was sand and hills and rings.',
	'The first thing I met, was a fly with a buzz,',
	'And the sky, with no clouds.',
	'The heat was hot, and the ground was dry,',
	'But the air was full of sound.',
	'',
	"I've been through the desert on a horse with no name,",
	'It felt good to be out of the rain.',
	'In the desert you can remember your name,',
	"'Cause there ain't no one for to give you no pain.",
	'',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la',
	'',
	'After two days, in the desert sun,',
	'My skin began to turn red.',
	'After three days, in the desert fun,',
	'I was looking at a river bed.',
	'And the story it told, of a river that flowed,',
	'Made me sad to think it was dead.',
	'',
	"You see, I've been through the desert on a horse with no name,",
	'It felt good to be out of the rain.',
	'In the desert you can remember your name,',
	"'Cause there ain't no one for to give you no pain.",
	'',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la',
	'',
	'After nine days, I let the horse run free,',
	"'Cause the desert had turned to sea.",
	'There were plants and birds and rocks and things',
	'There was sand and hills and rings.',
	'The ocean is a desert, with its life underground,',
	'And a perfect disguise above.',
	'Under the cities lies a heart made of ground,',
	'But the humans will give no love.',
	'',
	"You see, I've been through the desert on a horse with no name,",
	'It felt good to be out of the rain.',
	'In the desert you can remember your name,',
	"'Cause there ain't no one for to give you no pain.",
	'',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la',
	'',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la',
	'La, la, la la la la, la la la, la, la . . .',
];

export default AHorseWithNoName;
